<template>
  <v-container class="mt-2 mr-2" fluid>
		<v-row>
			<v-col cols="12" lg="6">
				<v-card class="transparent elevation-0">
					<!-- Titulo -->
				  <v-card-title primary-title>
				    Cotizador
				  </v-card-title>

				  <!-- Sección izquierda -->
				  <v-card-text class="pt-0">

				  	<!-- Opción de divisa -->
				    <v-radio-group
				    	class="pt-0"
				      v-model="divisaOp"
				      row
				      hide-details
				      dense
				      >
				      <v-radio
				      	dense
				        label="MXN"
				        value="MXN"
				        hide-details
				      ></v-radio>
				      <v-radio
				      	dense
				        label="USD"
				        value="USD"
				        hide-details
				      ></v-radio>
				    </v-radio-group>

				    <!-- Sección para cambio de USD -->
				    <v-row>
				    	<v-col cols="6" class="py-0">
					      <v-text-field
					      	v-if="divisaOp == 'USD'"
							    v-model="cambio"
							    label="Cambio"
							    hide-details
							  ></v-text-field>
				    	</v-col>
				    	<!-- Actualizar el cambio de divisa -->
				    	<v-col cols="6" class="py-0">
				    		<v-btn color="secondary" @click="cambioDivisa" v-if="divisaOp == 'USD'" small>Actualizar</v-btn>
				    	</v-col>
				    </v-row>

				    <!-- Limpiar lo que se ha hecho  -->
				   	<v-btn color="primary" @click="limpiar()" class="mt-8" small>Limpiar <v-icon right>mdi-broom</v-icon></v-btn>
						
				   	<!-- Selección del artículo -->
						<v-select 
							dense
							outlined
							:items="productos"
							v-model="articulo"
							item-text="nomart"
							item-value="idarticulo" 
							label="Categoría"
							persistent-hint
							single-line
							hide-details
							return-object
							class="pt-2"
						></v-select>

						<!-- Carousel de foto del artículo -->
						<v-carousel
							v-if="articulo.imagename[0].imagename != '' && articulo.imagename.length > 0 "
              cycle
              height="200"
              class="mt-2 mb-2 shadowCard"
              hide-delimiter-background
              show-arrows-on-hover
            >
              <v-carousel-item
                v-for="(image, i) in articulo.imagename"
                :key="i"
              >
                <v-img 
                  :src="url + image.imagename" 
                  height="200" contain/>
              </v-carousel-item>
            </v-carousel>

            <!-- Imagen por si no hay foto -->
						<img 
              v-else
              class="mt-2 mb-2 shadowCard"
							src="@/assets/blanco.jpg" 
							height="200" 
							contain 
						/>
						
						<!-- Categoría que pertenecen al artículos -->
						<v-tabs v-model="tab" background-color="white" centered  >
							<v-tabs-slider></v-tabs-slider>
							<v-tab v-for="item  in articulo.categorias" :key="item.id">
								{{ item.nomcatego }}
							</v-tab>
						</v-tabs>

						<!-- Desglose del las categorías del artículo -->
						<v-tabs-items v-model="tab" class="shadowCard">
							<v-tab-item  v-for="(item, i) in articulo.categorias" :key="item.id" class="elevation-0"> 
								<v-card class="elevation-0">
									<v-card-text class="py-0 pr-0">
										<v-checkbox 
											class="mt-2"
											dense
											hide-details
											v-if="desc.idcatego == item.idcatego"
											v-for="desc in articulo.descripcion"  :key="desc.iddescripcion"
											v-model="selectedDescrip" 
											:label="`${desc.descripcion}`" 
											@click="addDescrip(desc,i)"
				      				:value="desc">
										</v-checkbox>
									</v-card-text>
								</v-card>
							</v-tab-item>
						</v-tabs-items>

						<v-card class="shadowCard mt-4">
						  <v-card-text>
								<!-- Enviar el correo  -->
								<v-text-field
									class="pt-4"
								  v-model="correo"
								  label="Correo"
								  outlined
								  dense
								  hide-details
								></v-text-field>
								<v-card-actions class="px-0">
								  <v-btn color="secondary" block samll @click="sendMail()" tile class="subtitle-1">Enviar por Correo<v-icon right>mdi-email</v-icon></v-btn>
								</v-card-actions>

								<div>Aquí puedes ingresar cualquier información que desees, ya sea del cliente como nombre, correo, teléfono o de la cotización</div>
								<v-textarea
									v-model="nota"
									outlined
								>
								</v-textarea>
						  </v-card-text>
						</v-card>


				  </v-card-text>
				</v-card>	
			</v-col>
			<v-col cols="12" lg="6">
				<v-card class="transparent elevation-0">
					<!-- Notas sobre el artículo -->
					<v-textarea 
						class="mt-2"
						v-if="desgloce.length>0"
						v-model="desgloce[0].notas" label="Notas" outlined readonly
					/>

					<!-- Tabla con las caracterísitcas agregadas al artículo -->
				  <v-data-table
            :headers="headersArt"
            :items="desgloce"
            fixed-header
            height="500"
            hide-default-footer
            loading-text="Cargando..."
            dense
            class="shadowCard mt-2"
            :items-per-page="longitud"
            :mobile-breakpoint="250"
          >
            
            <!-- propiedades de la tabla, campos que se ocupan modificar -->
						<template v-slot:item.cant="props">
							<v-edit-dialog 
								:return-value.sync="props.item.cant"  persistent 
								@save="save" cancel open close 
							>
								<div>{{ props.item.cant }}</div>
								<template v-slot:input >
									<v-text-field 
										@keyup.enter="calcular"
										v-model="props.item.cant" 	
										label="Cantidad" 
										autofocus 
										color="primary" 
										class="mt-2">
									</v-text-field>
								</template>
							</v-edit-dialog>
						</template>

						<!-- Eliminar fila -->
						<template v-slot:item.actions="{ item }">
              <v-icon
              	v-if="item.descrip != articulo.nomart"
                color="red"
                small
                @click="limpiador = true,eliminarDescrip(item)"
              >
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>

          <!-- total de la cotización -->
          <v-card-title primary-title>
          	<v-spacer></v-spacer>
            Total: $ {{totalFormat}} {{divisaOp}}
          </v-card-title>
				</v-card>
			</v-col>
		</v-row>

		<!-- diaglogo para solicitar las medidas -->
		<v-row justify="space-around" v-if="dialogLongitudes">
	    <v-col cols="auto">
	      <v-dialog
	        transition="dialog-bottom-transition"
	        max-width="600"
	        v-model="dialogLongitudes"
	      >
	        <template>
	          <v-card>
	            <v-toolbar
	              color="primary"
	              dark
	            >unidades</v-toolbar>
	            <v-card-text>
	              <v-row>
	              	<v-col cols="6">
	              		<v-card-text>
		              		<v-text-field
		              			dense
		              			hide-details
		              		  label="Lado 1"
		              		  v-model="lado1"
		              		  type="number"
		              		  :suffix="unidad"
		              		></v-text-field>
		              		<v-text-field
		              			dense
		              			hide-details
		              		  label="Lado 2"
		              		  v-model="lado2"
		              		  type="number"
		              		  v-if="lados == 2 || lados == 3"
		              		  class="pt-4"
		              		  :suffix="unidad"
		              		></v-text-field>
		              		<v-text-field
		              			dense
		              			hide-details
		              		  label="Lado 3"
		              		  v-model="lado3"
		              		  type="number"
		              		  v-if="lados == 3"
		              		  class="pt-4"
		              		  :suffix="unidad"
		              		></v-text-field>
		              		<v-text-field
		              			dense
		              			hide-details
		              		  label="Factor 1"
		              		  v-model="factor1"
		              		  type="number"
		              		  v-if="lados > 1"
		              		  class="pt-4"
		              		></v-text-field>
		              		<v-text-field
		              			dense
		              			hide-details
		              		  label="Factor 2"
		              		  v-model="factor2"
		              		  type="number"
		              		  v-if="lados == 2 || lados == 3"
		              		  class="pt-4"
		              		></v-text-field>
		              		<v-text-field
		              			dense
		              			hide-details
		              		  label="Factor 3"
		              		  v-model="factor3"
		              		  type="number"
		              		  v-if="lados == 3"
		              		  class="pt-4"
		              		></v-text-field>
	              		</v-card-text>
	              	</v-col>
	              	<v-col cols="6">
	              		<v-card-text>
		              		<v-text-field
		              			readonly
		              			class="pt-4"
		              			dense
		              		  label="Medida final"
		              		  v-model="medida"
		              		  :suffix="unidad"
		              		></v-text-field>
	              		</v-card-text>
	              	</v-col>
	              </v-row>
	            </v-card-text>
	            <v-card-actions class="justify-end">
	              <v-btn
	                text
	                @click="dialogLongitudes = false, agregarDecripToTable()"
	              >Listo, Agregar</v-btn>
	            </v-card-actions>
	          </v-card>
	        </template>
	      </v-dialog>
	    </v-col>
	  </v-row>

	  <!-- diaglogo para solicitar las medidas -->
		<v-row justify="space-around" v-if="dialogCant">
	    <v-col cols="auto">
	      <v-dialog
	        transition="dialog-bottom-transition"
	        max-width="600"
	        v-model="dialogCant"
	      >
	        <template>
	          <v-card>
	            <v-toolbar
	              color="primary"
	              dark
	            >unidades</v-toolbar>
	            <v-card-text>
	              <v-row>
	              	<v-col cols="6">
	              		<v-card-text>
		              		<v-text-field
		              			dense
		              			hide-details
		              		  label="Cantidad"
		              		  v-model="cantidadPZA"
		              		  type="number"
		              		  :suffix="unidad"
		              		></v-text-field>
	              		</v-card-text>
	              	</v-col>
	              </v-row>
	            </v-card-text>
	            <v-card-actions class="justify-end">
	              <v-btn
	                text
	                @click="dialogCant = false, agregarDecripToTable()"
	              >Listo, Agregar</v-btn>
	            </v-card-actions>
	          </v-card>
	        </template>
	      </v-dialog>
	    </v-col>
	  </v-row>

	  <!-- Loader -->
	  <v-dialog
      v-model="dialogoOfCarga"
      hide-overlay
      persistent
      width="300"
      >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Enviando
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>


</template>

<script>
	import {mapGetters} from 'vuex'
	import Vue from 'vue';
	// var numeral = require('numeral');

	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
	
	export default{

		components:{
      Alerta,
      carga,
    },

    mixins:[ validarErrores ],

		data: () => ({
			nota:'',

			dialogoOfCarga:false,
			dialogLongitudes: false,
			// Divisa:
			divisaOp:'MXN',

			date: new Date().toISOString().substr(0, 10),
			// snackbar
			snackbar:false,
			color:'success',
			mensaje:'',

			// correo 
			print: false,
			correo:'',
			output: null,

			selectedDescrip:[],
			selectedDescrip2:[],
			limpiador: false,

			original:[],
			divisa: 'MXN',
			cambio:0,
			yacambio: false,
      url:'',


			tab: null,
			tabActual: [],
			rowAnterior:'',
			totalFormat:0,
			total:0,
			pos:0,
			row: null,
			articulos:[],
			articulo:{
				idarticulo:'',
				nomart:'',
				precio:'',
				cant: 1,
				categorias:[],
				imagename:[{imagename:''}],
			},
			headersArt: [],
      desgloce:[],
      longitud:5,

      // Lados
      lados:0,
      lado1:1,
      lado2:1,
      lado3:1,
      factor:0,
      factor1:0,
      factor2:0,
      factor3:0,
      medida:0,
      unidad:'',
      descripToAdd:[],
      tipoUnidad:'',
      // unica pieza
      cantidadPZA:0,
			dialogCant:false,

			productos:[],
		}),

		created(){

			if(this.getdatosUsuario.admin == 'ADMIN'){
				this.headersArt= [
	        { text: '#',           align: 'start', value: 'no'},
	        { text: 'Descripción', align: 'start', value: 'descrip'},
	        { text: 'Medida',      align: 'start', value: 'cant'},
	        { text: 'Unidad',      align: 'start', value: 'unidad'},
	        { text: 'P.U',         align: 'start', value: 'preciou'},
	        { text: 'Costo',       align: 'start', value: 'precio'},
	        { text: 'Acciones',    align: 'start', value: 'actions'},
	      ]
			}else{
				this.headersArt = [
	        { text: '#',           align: 'start', value: 'no'},
	        { text: 'Descripción', align: 'start', value: 'descrip'},
	        { text: 'Medida',    align: 'start', value: 'cant'},
	        { text: 'Acciones',    align: 'start', value: 'actions'},
	      ]
			}
			this.url = this.$http.options.root + 'fotos/'
			this.initialize()
			this.getProductos()
			this.hora()
		},

		computed:{
      	
			...mapGetters('login',['getdatosUsuario']),
		},

		

		watch:{
			lado1(){
				this.medida = ((parseFloat(this.lado1) * this.factor1) * (parseFloat(this.lado2) * this.factor2)* (parseFloat(this.lado3) * this.factor3))
				this.medida = this.medida.toFixed(4)
			},

			lado2(){
				this.medida = ((parseFloat(this.lado1) * this.factor1) * (parseFloat(this.lado2) * this.factor2)* (parseFloat(this.lado3) * this.factor3))
				this.medida = this.medida.toFixed(4)
			},

			lado3(){
				this.medida = ((parseFloat(this.lado1) * this.factor1) * (parseFloat(this.lado2) * this.factor2)* (parseFloat(this.lado3) * this.factor3))
				this.medida = this.medida.toFixed(4)
			},

			divisaOp(){
				// Como es un watch, al momento de limpiar las variables se ejecuta, entonces, le decimos, 
				// Hey! solo estamos limpiando, no hagas nada
				if(this.limpiador == false ){

					if(this.divisaOp == 'MXN'){
						for(const i in this.desgloce){
							this.desgloce[i].preciou = this.desgloce[i].preciooriginal
							this.desgloce[i].precio = this.desgloce[i].preciou * this.desgloce[i].cant
						}
					}

					if(this.divisaOp == 'USD' && this.cambio > 0){
						for(const i in this.desgloce){
							this.desgloce[i].preciou = this.desgloce[i].preciooriginal / this.cambio
							this.desgloce[i].precio = this.desgloce[i].preciou * this.desgloce[i].cant
						}
					}

					this.calcular()
				}
			},

			desgloce(){
				// Como es un watch, al momento de limpiar las variables se ejecuta, entonces, le decimos, 
				// Hey! solo estamos limpiando, no hagas nada
				if(this.limpiador == false ){
					this.calcular()
				}

				this.longitud = this.desgloce.length
			},

			articulo(){
				// Como es un watch, al momento de limpiar las variables se ejecuta, entonces, le decimos, 
				// Hey! solo estamos limpiando, no hagas nada
				if(this.limpiador == false ){

					this.tab = null;
					this.desgloce = []

					if(this.divisaOp == 'USD'){
						this.desgloce.push({
							no: 1,
							descrip: this.articulo.nomart,
							cant: 1,
							preciou: this.articulo.precio / this.cambio,
							precio: this.articulo.precio,
							preciooriginal: this.articulo.precio,
							idcatego: this.articulo.idcatego,
							imagename: this.articulo.imagename,
							notas: this.articulo.notas
						})
					}else{
						this.desgloce.push({
							no: 1,
							descrip: this.articulo.nomart,
							cant: 1,
							preciou: this.articulo.precio,
							precio: this.articulo.precio,
							preciooriginal: this.articulo.precio,
							idcatego: this.articulo.idcatego,
							imagename: this.articulo.imagename,
							notas: this.articulo.notas
						})
					}
					this.calcular()
				}

				this.limpiador = false
			}
		},

		methods: {

			// Inicializamos nuestro componente con algunos datos
			initialize () {
				// Vaciamos el arreglo
        this.articulos = []
        this.$http.get('articulos.all').then(response=>{
        	// Empezamos a llenar todas nuestras variables
        	this.articulos = response.body
        	this.longitud = this.articulos.length
        	this.loading = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getProductos () {
        this.productos = []
        this.cargar = true
        this.$http.get('articulos.all').then(response=>{
        	this.productos = response.body
          this.cargar    = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },


      addDescrip(item, pos){
      	// console.log('item',item)
      	// Como es un watch, al momento de limpiar las variables se ejecuta, entonces, le decimos, 
				// Hey! solo estamos limpiando, no hagas nada
				if(this.limpiador == true ){
					return
				}


				// Necesitamos saber que tipo de descripción es, ya que algunos son de tipo longitud
				this.selectedDescrip2.push(item)
				// nos ayudara a guardar el valor en una variables más pequela
				var carac = item
				console.log('carac',carac)
				this.tipoUnidad = carac.tipo
				if(this.tipoUnidad == 'PIEZA'){
					this.cantidadPZA = carac.cantidadPZA
					this.unidad = carac.unidad
					this.factor = parseFloat(carac.factor)
					this.factor1 = parseFloat(carac.factor1)
					this.factor2 = parseFloat(carac.factor2)
					this.factor3 = parseFloat(carac.factor3)
					this.medida = 0
					this.descripToAdd = carac
					this.dialogCant = true
					this.tipoUnidad = carac.tipo
				}else{
					console.log(carac)
					this.lados = carac.lados
					this.unidad = carac.unidad
					this.factor = parseFloat(carac.factor)
					this.factor1 = parseFloat(carac.factor1)
					this.factor2 = parseFloat(carac.factor2)
					this.factor3 = parseFloat(carac.factor3)
					this.medida = 0
					this.descripToAdd = carac
					this.dialogLongitudes = true
					this.tipoUnidad = carac.tipo
				}

				this.selectedDescrip = this.selectedDescrip2
      },

      // Agregar la descripción a la tabla de descripciones
      agregarDecripToTable(){
      	// inicializamos una variables para guardar la cantidad en pzs o medidas
      	var cant = 0
      	if(this.tipoUnidad == 'PIEZA'){
					cant = this.cantidadPZA
				}else{
					cant = this.medida
				}

				//verificamos si es peso o dolar y agregamos al desglose
    		if(this.divisaOp == 'USD'){
					this.desgloce.push({
						no: 0,
						descrip:        this.descripToAdd.descripcion,
						cant:           cant,
						preciou:        this.descripToAdd.precio / this.cambio,
						precio:         this.descripToAdd.precio ,
						preciooriginal: this.descripToAdd.precio ,
						idcatego:       this.descripToAdd.idcatego,
						imagename:      this.descripToAdd.imagename,
						unidad:         this.descripToAdd.unidad
					})
				}else{
					this.desgloce.push({
						no: 0,
						descrip:        this.descripToAdd.descripcion,
						cant:           cant,
						preciou:        this.descripToAdd.precio ,
						precio:         this.descripToAdd.precio ,
						preciooriginal: this.descripToAdd.precio ,
						idcatego:       this.descripToAdd.idcatego,
						imagename:      this.descripToAdd.imagename,
						unidad:         this.descripToAdd.unidad
					})
				}

				// Agregamos el numero de renglon
				for(const i in this.desgloce){
					this.desgloce[i].no = parseInt(i) + 1
				}

				this.medida = 0
				this.lado1 = 1
				this.lado2 = 1
				this.lado3 = 1
				this.factor = 1

				// recalcular
				this.calcular()
      },

      sendMail() {
	    	// Creamos el html que vamos a mandar por correo
			  var html = ``
			  for(const i in this.desgloce){
			  	html = html + `
			  		<tr>
			  			<td>`+ this.desgloce[i].no +`</td>
			  			<td>`+ this.desgloce[i].descrip +`</td>
			  			<td>`+ this.desgloce[i].cant +`</td>
			  			<td>`+ this.desgloce[i].unidad +`</td>
			  		</tr>
			  	`
			  }

			  // Preparamos el parametro que vamos a mandar para enviar por correo
			  var payload = {
			  	nota: this.nota,
			  	html: html,
			  	foto: this.url + this.articulo.imagename[0].imagename,
			  	total: this.totalFormat + ' ' + this.divisaOp,
			  	nombre: this.articulo.nomart,
			  	correo: this.correo,
			  	no: this.hora()
			  }
			  this.dialogoOfCarga=true
			  // Hacemos el envío de datos al servidor
			  this.$http.post('correos.send', payload).then(response=>{
			  	this.color = 'success'
			  	this.mensaje = 'Correo enviado con exito'
			  	this.snackbar = true
			    this.html = ``
			    this.dialogoOfCarga = false
			    this.guardarInfo(payload)
			    this.limpiar()
			  }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
			},

			guardarInfo(info){
				var payload = {
					idusuariosweb: this.getdatosUsuario.id,
					fecha: info.no.substr(0,10),
					hora: info.no.substr(11,18),
					nota: this.nota,
					nomdocum: info.no
				}

				console.log(payload)

				this.$http.post('historial.add', payload).then(response=>{
					console.log(response)
				}).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
			},


			// Funcion para obetener la hora en formato de folio 
			hora(){
				var today=new Date();

				var h=today.getHours();

				var m=today.getMinutes();

				var s=today.getSeconds();

				if(h < 10){h = '0' + h}
				if(m < 10){m = '0' + m}
				if(s < 10){s = '0' + s}
				return this.date + '-' + h + '-' + m + '-' + s

			},

			// Cambiar de divisa
			cambioDivisa(){
				// Verificamos en que divisa se necesita el pedido 
				if(this.divisaOp == 'USD'){
					// Recorremos todo el arreglo de desglose
					for(const i in this.desgloce){
						// Calculamos el precio en dolares
	      		this.desgloce[i].preciou = this.desgloce[i].preciooriginal / this.cambio
						this.desgloce[i].precio = this.desgloce[i].preciou * this.desgloce[i].cant
	      	}
				}
				// Recalculamos todo
				this.calcular()
			},

      // Recalculamos para porder sacar el precio total del pedido
      calcular(){
      	this.total = 0 //inicilizamos la suma en 0
      	// calcular el total
      	for(const i in this.desgloce){
      		this.desgloce[i].precio = this.desgloce[i].preciou *  this.desgloce[i].cant
      		this.total  = this.desgloce[i].precio  + this.total
      		this.desgloce[i].precio = this.desgloce[i].precio.toFixed(4)
      		if(this.desgloce[i].preciou){
      			this.desgloce[i].preciou = parseFloat(this.desgloce[i].preciou.toFixed(4))
      		}
      	}

      	// Le damos el formato al total del pedido
      	this.totalFormat = numeral(this.total).format('0,0.000');


      	this.limpiador = false
      },

      // Eliminamos la descripción del pedido
      eliminarDescrip(item){
      	for(const i in this.desgloce){
      		if(this.desgloce[i].descrip == item.descrip){
      			this.desgloce.splice(i, 1)
      			// Eliminamos la posición también del selectedDescrip, se le quita un 1 a la i, por que hay que recordar
      			// el arreglo del desgloce ya tiene un dato agregado al principio
      			this.selectedDescrip.splice(i-1,1)
      		}
      	}

      	for(const i in this.selectedDescrip){
      		console.log(this.selectedDescrip[i])
      		if(this.selectedDescrip[i].descripcion == item.descrip){
      			// Eliminamos la posición también del selectedDescrip, se le quita un 1 a la i, por que hay que recordar
      			// el arreglo del desgloce ya tiene un dato agregado al principio
      			this.selectedDescrip.splice(i,1)
      		}
      	}

      	// Agregamos el numero de renglon
				for(const i in this.desgloce){
					this.desgloce[i].no = parseInt(i) + 1
				}
      	// Calculamos de nuevo el total
      	this.calcular()
      },

      save(){
      	this.calcular()
      },

      // limpiamos todo
      limpiar(){
      	this.limpiador = true
      	this.articulo =  {
					idarticulo:'',
					nomart:'',
					precio:'',
					cant: 1,
					categorias:[],
					imagename:[{imagename:''}]
				}

				this.nota = ''
				this.selectedDescrip2 = [] 
      	this.desgloce = []
      	this.selectedDescrip = []
      	this.totalFormat = '0.00'
      	this.correo = ''
      }
    }

	}
</script>

